
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      customers: {
        Row: {
          id: string;
          name: string;
          email: string;
          phone: string;
          address: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          name: string;
          email: string;
          phone: string;
          address: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          name?: string;
          email?: string;
          phone?: string;
          address?: string;
          updated_at?: string;
        };
      };
      inventory: {
        Row: {
          id: string;
          name: string;
          category: string;
          quantity: number;
          price: number;
          cost: number;
          barcode: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          name: string;
          category: string;
          quantity: number;
          price: number;
          cost: number;
          barcode: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          name?: string;
          category?: string;
          quantity?: number;
          price?: number;
          cost?: number;
          barcode?: string;
          updated_at?: string;
        };
      };
      orders: {
        Row: {
          id: string;
          customer_id: string;
          total_amount: number;
          status: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          customer_id: string;
          total_amount: number;
          status: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          customer_id?: string;
          total_amount?: number;
          status?: string;
          updated_at?: string;
        };
      };
      invoices: {
        Row: {
          id: string;
          invoice_no: string;
          customer_name: string;
          customer_phone: string;
          customer_address: string;
          date: string;
          total_amount: number;
          status: string;
          created_at: string;
        };
        Insert: {
          id?: string;
          invoice_no: string;
          customer_name: string;
          customer_phone: string;
          customer_address: string;
          date?: string;
          total_amount: number;
          status?: string;
          created_at?: string;
        };
        Update: {
          id?: string;
          invoice_no?: string;
          customer_name?: string;
          customer_phone?: string;
          customer_address?: string;
          date?: string;
          total_amount?: number;
          status?: string;
        };
      };
    };
  };
};
